import { AxiosResponse } from 'axios';
import { axios } from './axios';
import { PartnerKey } from '../types';

const find = async () => {
  try {
    const response: AxiosResponse<PartnerKey[]> = await axios.get(`/partnerKeys`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const create = async (serviceProviderId: number | null = null) => {
  try {
    const response: AxiosResponse<PartnerKey> = await axios.post(`/partnerKeys`, {
      serviceProviderId: serviceProviderId?.toString(),
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const revoke = async (partnerKeyId: number) => {
  try {
    const response: AxiosResponse<PartnerKey> = await axios.put(`/partnerKeys/${partnerKeyId}/revoke`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export { create, find, revoke };
